import axios from 'axios'

export default {
    name: 'Header',
    data() {
        return {
            userData: '',
            isDropdownOpen: false,
            inputSearch: '',
            currentUserName: ""
        }
    },
    created() {
        window.addEventListener("click", this.close)
    },
    computed: {
        currentClient(){
            return this.$store.state.userData.current
        }
    },
    mounted() {
        if (localStorage.userData) {
            this.userData = JSON.parse(localStorage.userData)
            this.currentUserName = this.userData.data.username
        }
        this.$nextTick(() => {
            if(localStorage.selectedMenu){
                this.$store.state.menu[localStorage.selectedMenu].isExpanded = true;
            } else this.$store.state.menu[0].isExpanded = true;
        })
    },
    beforeDestroy() {
        window.removeEventListener("click", this.close)
    },
    methods: {
        openDropdown() {
            this.isDropdownOpen = !this.isDropdownOpen
        },
        close(event) {
            if (!this.$el.contains(event.target)) {
                this.isDropdownOpen = false
            }
        },

        clearSearchBox() {
            this.inputSearch = ''
        },
        changeClients(id) {
            let url = "/api/users/switch_clients/" + id + "/"
            axios.post(url).then((res) => {
                console.log('success')
                axios.defaults.headers.common['token'] = res.data.data.token
                localStorage.userData = JSON.stringify(res.data)
                localStorage.removeItem('selectedMenu')
                this.$nextTick(() => {
                    this.$store.dispatch('setUser')
                    this.$store.dispatch('setMenu')
                    window.location = this.$store.state.menu[0].submenuItems[0].link;
                })
            }).catch(err => console.log(err))
        },
        logout() {
            // let url="/api/logout/"
            // axios.get(url).then((Response) => {
            //     const resData=Response.data
                
            // }).catch((err) => {
            //     console.log(err)
            // });
            this.$store.dispatch("unsetMenu")
            localStorage.removeItem('selectedMenu')
            this.$router.push("/login");
            
        },
    }
}


